<template>
  <validation-observer ref="validator" #default="{valid}">
    <b-form
      :class="[inline ? 'gap-2 items-center' : '']"
      :inline="inline"
      @submit.prevent="submit"
      @reset.prevent="clear"
    >

      <validation-provider
        #default="validationContext"
        name="name"
        rules="required"
        class="flex-grow"
        slim
      >
        <b-form-group
          :class="[inline ? 'flex-col items-start pb-1 inline-input-group': '']"
          id="input-group-1"
          label="Nome:"
          label-for="list-name"
        >
          <b-form-input
            class="pr-0 w-full"
            id="list-name"
            type="text"
            v-model="name"
            :state="getValidationState(validationContext)"
          ></b-form-input>
          <b-form-invalid-feedback :class="[{
            'absolute': inline
          }]">
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <validation-provider
        #default="validationContext"
        name="email"
        rules="email|required"
        class="flex-grow"
        slim
      >
        <b-form-group
          id="input-group-2"
          label="Email:"
          label-for="contact-email"
          :class="[inline ? 'flex-col items-start pb-1 inline-input-group': '']"
        >
          <b-form-input
            id="contact-email"
            class="pr-0 w-full"
            type="email"
            v-model="email"
            :state="getValidationState(validationContext)"
          ></b-form-input>
          <b-form-invalid-feedback :class="[{
            'absolute': inline
          }]">
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <validation-provider
        #default="validationContext"
        name="phone"
        class="flex-grow"
        slim
      >
        <b-form-group
          id="input-group-3"
          label="Fone:"
          label-for="phone"
          :class="[inline ? 'flex-col items-start pb-1 inline-input-group': '']"
        >
          <b-form-input
            id="phone"
            class="pr-0 w-full"
            v-model="phone"
            :state="getValidationState(validationContext)"
          ></b-form-input>
          <b-form-invalid-feedback :class="[{
            'absolute': inline
          }]">
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <template v-if="(showSubmit || showReset) && !inlineInput">
        <b-form-row v-if="!compact" :class="['justify-end', inline ? 'ml-auto' : '' ]">
          <b-col v-if="showSubmit" cols="auto">
            <slot name="submit-button" :valid="valid">
              <b-button :disabled="!valid" type="submit" variant="primary">
                <slot name="submit-button-text">Salvar</slot>
              </b-button>
            </slot>
          </b-col>
          <b-col v-if="showReset" cols="auto">
            <slot name="reset-button">
              <b-button type="reset" variant="outline-secondary">
                <slot name="reset-button-text">Limpar</slot>
              </b-button>
            </slot>
          </b-col>
        </b-form-row>
        <b-form-group class="flex-grow flex justify-end" v-else>
          <div class="flex gap-2">
            <slot name="submit-button" :valid="valid">
              <b-button :disabled="!valid" type="submit" variant="primary">
                <slot name="submit-button-text">Salvar</slot>
              </b-button>
            </slot>
            <slot name="reset-button">
              <b-button type="reset" variant="outline-secondary">
                <slot name="reset-button-text">Limpar</slot>
              </b-button>
            </slot>
          </div>
        </b-form-group>
      </template>

      <b-input-group v-if="inlineInput">
        <b-input-group-append>
          <slot name="search-button">
            <b-button variant="outline-primary" @click="search">
              <feather-icon
                icon="SearchIcon"
                class="mr-50"
              />
              <span class="align-middle">Buscar</span>
            </b-button>
          </slot>
          <b-button type="submit" variant="outline-primary">
            <feather-icon
              icon="PlusIcon"
              class="mr-50"
            />
            <span class="align-middle">Incluir</span>
          </b-button>
          <b-button type="reset" variant="outline-primary">
            <feather-icon
              icon="XIcon"
              class="mr-50"
            />
            <span class="align-middle">Limpar</span>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormRow,
  BCol,
  BFormInvalidFeedback,
  BInputGroup,
  BInputGroupAppend
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import { required, min, email } from '@validations'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormRow,
    BFormInvalidFeedback,
    BCol,
    ValidationObserver,
    ValidationProvider,
    BInputGroup,
    BInputGroupAppend
  },

  props: {
    model: {
      type: Object,
      default: () => ({
        name: '',
        email: '',
        phone: ''
      })
    },
    showSubmit: {
      type: Boolean,
      default: true
    },
    showReset: {
      type: Boolean,
      default: true
    },
    inline: {
      type: Boolean,
      default: false
    },
    inlineInput: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    name: '',
    email: '',
    phone: '',
    required, email, min
  }),

  methods: {
    loadModel(model) {
      this.name = model.name || ''
      this.email = model.email || ''
      this.phone = model.phone || ''
    },
    submit(event, eventname='submit') {
      this.$emit(`${eventname}`, {name: this.name, email: this.email, phone: this.phone})
    },
    clear() {
      this.clearValidationErrors()
      this.$emit('reset')
      this.name = ''
      this.email = ''
      this.phone = ''
    },
    search() {
      this.submit(null, 'search')
    },
    getValidationState({ invalid, validated, ...obj }){
      const valid = !invalid
      return (
        !validated ? null : valid
      )
    },
    showValidationErrors(error) {
      this.showErrors(this.$refs.validator, error)
    },
    clearValidationErrors() {
      this.$refs.validator.reset()
    }
  },

  watch: {
    model(value) {
      if (value) this.loadModel(value)
    },
    'model.name'(value) {
      if (value) this.name = value
    },
    'model.phone'(value) {
      if (value) this.phone = value
    },
    'model.email'(value) {
      if (value) this.email = value
    }
  },

  mounted() {
    if (this.model) {
      this.loadModel(this.model)
    }
  }
}
</script>

<style lang="scss">
  .inline-input-group > div:nth-child(2) {
    width: 100%;
  }
</style>
